var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 323,
    viewBox: "0 0 325 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.566 218.998C277.951 295.232 191.859 327.975 124.404 322.392C105.986 320.868 68.9294 317.801 39.9945 290.438C-15.572 237.891 -7.01411 128.051 46.1783 63.3837C53.029 55.0555 100.445 -0.739456 174.333 0.0074297C228.43 0.553677 266.401 31.1134 271.018 34.9197C276.85 39.7292 289.714 51.1575 301.308 69.2881C328.552 111.89 330.947 171.36 310.566 218.998Z",
    fill: "url(#paint0_linear_1507_9607)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.839 265.905C309.839 269.054 307.471 271.63 304.576 271.63H20.008C17.1132 271.63 14.7462 269.054 14.7462 265.905L12.3779 87.8217C12.3779 84.673 15.7842 78.5251 22.0283 78.9878L300.14 71.1513C303.771 71.0492 307.283 72.5708 309.854 75.3624C312.426 78.1539 313.833 81.9707 313.748 85.9209L309.839 265.905Z",
    fill: "url(#paint1_linear_1507_9607)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.643 260.413C304.643 263.395 302.403 265.835 299.664 265.835H26.87C24.1318 265.835 21.8911 263.395 21.8911 260.413L19.6562 98.7472C19.9195 89.0192 27.7514 85.5225 32.4994 85.7289C32.4994 85.7289 249.869 79.3781 299.044 77.9411C301.595 77.8669 304.062 78.9374 305.869 80.8997C307.676 82.862 308.67 85.548 308.606 88.3268L304.643 260.413Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322.638 286.414H1.78992C1.31094 286.414 0.918945 286.022 0.918945 285.543V271.637C0.918945 271.158 1.31094 270.766 1.78992 270.766H322.638C323.117 270.766 323.509 271.158 323.509 271.637V285.543C323.508 286.022 323.117 286.414 322.638 286.414Z",
    fill: "url(#paint2_linear_1507_9607)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5935 95.3142L220.442 90.8653C223.529 90.7934 226.085 92.6293 226.085 94.921V97.0306C226.085 99.2318 223.719 101.031 220.753 101.086L30.9867 104.651C28.0177 104.707 25.53 102.995 25.3839 100.795L25.3027 99.5693C25.1519 97.3031 27.5364 95.3861 30.5935 95.3142Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.416 95.8977C220.82 92.6816 218.586 89.7544 215.428 89.3589C212.27 88.9635 209.383 91.2493 208.981 94.4654C208.77 96.1459 209.28 97.7463 210.266 98.9501L204.387 103.473C204.016 103.772 203.978 104.324 204.304 104.671L204.357 104.728C204.646 105.035 205.131 105.048 205.436 104.757L210.776 99.4976C211.629 100.3 212.726 100.85 213.969 101.005C217.126 101.4 220.013 99.1137 220.416 95.8977ZM214.164 99.4465C211.851 99.1566 210.215 97.0122 210.511 94.6567C210.806 92.3012 212.921 90.6265 215.233 90.9165C217.546 91.2064 219.182 93.3508 218.886 95.7063C218.591 98.0618 216.477 99.7365 214.164 99.4465Z",
    fill: "url(#paint3_linear_1507_9607)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.019 177.566L30.1852 254.16C30.2919 256.742 33.8976 258.792 38.2687 258.756L131.214 258C135.584 257.964 139.091 255.858 139.081 253.277L138.757 175.965C138.746 173.32 135.051 171.198 130.573 171.267L34.7848 172.741C30.3858 172.807 26.9112 174.967 27.019 177.566Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.952 109.783L215.218 109.074C221.181 109.001 226.127 110.938 226.177 113.367L227.166 161.515C227.216 163.941 222.357 165.911 216.395 165.882L155.737 165.579C152.324 165.562 149.557 164.448 149.477 163.06L146.632 114.214C146.493 111.833 151.103 109.854 156.952 109.783Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6425 108.678L124.557 107.947C133.044 107.873 140.081 109.869 140.151 112.371L141.559 161.993C141.63 164.494 134.716 166.523 126.232 166.493L39.9133 166.181C35.0574 166.164 31.1189 165.017 31.004 163.586L26.9565 113.245C26.7593 110.791 33.3201 108.751 41.6425 108.678Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.814 171.784L215.08 170.659C221.044 170.545 225.989 173.618 226.039 177.471L227.028 253.883C227.078 257.733 222.22 260.859 216.257 260.811L155.6 260.331C152.186 260.304 149.419 258.537 149.339 256.333L146.494 178.815C146.355 175.039 150.965 171.897 156.814 171.784Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.35 88.7183L287.807 87.9864C292.46 87.9111 296.318 89.9117 296.357 92.4202L297.129 142.154C297.169 144.66 293.378 146.695 288.726 146.665L241.403 146.351C238.74 146.334 236.582 145.184 236.518 143.75L234.299 93.2958C234.19 90.836 237.787 88.7913 242.35 88.7183Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.468 153.341L288.924 152.767C293.577 152.708 297.435 154.278 297.474 156.245L298.247 195.268C298.286 197.235 294.495 198.831 289.843 198.806L242.52 198.56C239.857 198.546 237.699 197.644 237.635 196.519L235.416 156.932C235.307 155.003 238.904 153.398 243.468 153.341Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M245.634 207.522L291.091 206.861C295.744 206.794 299.602 208.601 299.641 210.866L300.413 255.787C300.453 258.051 296.662 259.888 292.01 259.86L244.687 259.577C242.024 259.561 239.866 258.523 239.802 257.227L237.583 211.657C237.476 209.435 241.072 207.588 245.634 207.522Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.517 32.5793C251.572 32.4564 251.626 32.3323 251.684 32.2105C254.477 26.3143 259.103 25.0942 263.179 27.0264C267.256 28.9585 269.239 33.31 266.445 39.2062C266.421 39.2572 266.394 39.3082 266.37 39.3581C263.621 37.3018 258.345 33.9722 251.517 32.5793Z",
    fill: "url(#paint4_linear_1507_9607)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M266.369 39.3581C263.535 45.1905 257.1 50.2912 253.059 48.3764C249.067 46.4848 248.897 38.4477 251.517 32.5781C258.345 33.971 263.621 37.3007 266.369 39.3581Z",
    fill: "url(#paint5_linear_1507_9607)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M259.25 29.436C260.637 26.9355 261.855 24.3516 262.824 21.654C263.293 20.3005 263.708 18.9193 263.93 17.4823C264.046 16.7656 264.094 16.0303 264.06 15.2881C264.029 14.5481 263.861 13.7792 263.465 13.0915C263.075 12.3991 262.387 11.8714 261.645 11.629C260.895 11.3681 260.139 11.3275 259.383 11.3785C258.63 11.4319 257.814 11.6534 257.186 12.224C256.54 12.7841 256.269 13.6412 256.224 14.4159C256.174 15.2057 256.335 15.9677 256.594 16.6833C256.862 17.3965 257.22 18.0808 257.799 18.663C258.095 18.9413 258.444 19.2359 258.984 19.3147C259.253 19.3472 259.554 19.2916 259.789 19.1535C260.036 19.0167 260.187 18.8323 260.338 18.6479C260.815 17.8929 260.924 17.1367 261.038 16.3991C261.081 16.1219 260.891 15.8621 260.612 15.8192C260.335 15.7763 260.075 15.9665 260.033 16.2449C260.031 16.2495 260.031 16.2553 260.03 16.2599L260.028 16.2843C259.949 16.943 259.817 17.6319 259.533 18.09C259.374 18.3011 259.254 18.373 259.094 18.3603C258.919 18.3487 258.667 18.1909 258.456 17.9868C258.019 17.5681 257.679 16.9744 257.443 16.3655C257.209 15.7531 257.061 15.0944 257.094 14.4623C257.124 13.8349 257.314 13.226 257.755 12.8363C258.18 12.4327 258.802 12.2298 259.454 12.1741C260.774 12.0396 262.202 12.3539 262.846 13.4649C263.17 14.0042 263.339 14.6618 263.378 15.3368C263.419 16.0129 263.39 16.7041 263.29 17.3919C263.102 18.7697 262.721 20.1312 262.282 21.4696C261.376 24.1394 260.206 26.7361 258.879 29.2284L258.875 29.2342C258.819 29.3386 258.859 29.4673 258.963 29.523C259.065 29.5752 259.194 29.5369 259.25 29.436Z",
    fill: "url(#paint6_linear_1507_9607)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.77 31.5468C264.859 28.9408 266.128 26.3916 267.621 23.999C268.38 22.8126 269.191 21.6552 270.139 20.6369C270.609 20.1243 271.125 19.6639 271.673 19.2672C272.221 18.8694 272.837 18.5841 273.459 18.4936C274.727 18.2884 275.875 19.1953 276.606 20.3017C276.975 20.841 277.212 21.451 277.169 22.0367C277.147 22.6247 276.795 23.1582 276.329 23.578C275.86 24.0037 275.256 24.3064 274.634 24.5128C274.013 24.7158 273.339 24.8283 272.738 24.7552C272.446 24.7204 272.165 24.6253 272.044 24.4977C271.933 24.3829 271.915 24.2449 271.976 23.9874C272.151 23.4771 272.599 22.9379 273.06 22.46L273.075 22.4438C273.27 22.242 273.264 21.9196 273.063 21.7247C272.861 21.5299 272.538 21.5357 272.344 21.7375C272.34 21.741 272.336 21.7468 272.332 21.7503C271.832 22.3058 271.317 22.8694 271.035 23.7161C270.987 23.9492 270.94 24.1823 270.99 24.4606C271.032 24.7297 271.18 24.9976 271.375 25.1855C271.778 25.5543 272.228 25.6378 272.63 25.69C273.447 25.77 274.204 25.6146 274.925 25.3699C275.643 25.117 276.334 24.7598 276.914 24.2205C277.485 23.6952 277.977 22.9425 278.001 22.0878C278.045 21.2411 277.699 20.4687 277.265 19.8529C276.825 19.2359 276.315 18.6757 275.639 18.2617C274.981 17.8419 274.138 17.6435 273.354 17.7781C272.572 17.9068 271.869 18.264 271.277 18.7082C270.682 19.1524 270.142 19.6546 269.661 20.1985C268.689 21.2806 267.883 22.4763 267.133 23.6952C265.658 26.1539 264.429 28.7332 263.373 31.389C263.329 31.498 263.382 31.6233 263.492 31.6662C263.6 31.7091 263.723 31.6581 263.768 31.5502L263.77 31.5468Z",
    fill: "url(#paint7_linear_1507_9607)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M260.314 34.332C260.314 34.332 257.923 55.8932 266.362 57.0796C274.798 58.2672 274.144 45.896 260.314 34.332Z",
    fill: "#00A660"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M260.313 34.3306C260.313 34.3306 245.136 49.832 238.876 44.0517C232.616 38.2727 242.606 30.9476 260.313 34.3306Z",
    fill: "#00A660"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M259.026 35.1083C259.026 35.1083 238.637 42.5157 235.494 34.5968C232.351 26.6768 244.527 24.3956 259.026 35.1083Z",
    fill: "#00A660"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M261.138 36.1094C261.138 36.1094 268.313 56.5815 276.434 53.9998C284.553 51.4194 278.611 40.5501 261.138 36.1094Z",
    fill: "#00A660"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M266.244 55.722C266.31 55.7533 266.383 55.7707 266.461 55.7707C268.383 55.7753 269.683 55.1699 270.324 53.9707C272.208 50.4474 267.259 43.0052 267.048 42.6897C266.89 42.4566 266.576 42.3952 266.343 42.5506C266.11 42.7071 266.048 43.0226 266.203 43.2557C267.55 45.2621 270.753 51.0122 269.428 53.4918C268.978 54.3326 267.98 54.7582 266.463 54.7547C266.183 54.7536 265.954 54.9809 265.954 55.2616C265.953 55.4645 266.072 55.6396 266.244 55.722Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M259.911 35.1798C259.911 35.1798 252.713 24.0148 248.484 22.013C243.927 19.8547 236.979 21.868 233.567 23.109C232.9 23.3514 232.94 24.3012 233.621 24.5007C241.415 26.7889 250.431 30.6799 259.911 35.1798Z",
    fill: "url(#paint8_linear_1507_9607)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M259.174 34.832C259.174 34.832 272.373 33.3348 276.6 35.34C281.156 37.5006 283.996 44.153 285.197 47.5801C285.431 48.2493 284.671 48.8211 284.085 48.4198C277.38 43.8364 268.66 39.3215 259.174 34.832Z",
    fill: "url(#paint9_linear_1507_9607)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M282.47 45.2243C282.598 45.2858 282.751 45.2927 282.893 45.2301C283.149 45.1164 283.266 44.8172 283.153 44.5597C282.969 44.1457 278.596 34.4269 271.322 35.0868C271.042 35.1123 270.836 35.3594 270.862 35.6389C270.887 35.9184 271.134 36.1248 271.414 36.0993C277.966 35.5043 282.18 44.8752 282.221 44.9703C282.274 45.0863 282.363 45.1733 282.47 45.2243Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.555 264.607L227.479 132.173C227.456 130.72 228.858 129.532 230.594 129.532C233.403 129.532 235.679 127.627 235.679 125.277V92.9277C235.679 90.868 237.718 89.2188 240.177 89.2872L251.378 89.598C254.135 89.6746 256.338 91.5441 256.389 93.8532L260.22 264.608H229.555V264.607Z",
    fill: "url(#paint10_linear_1507_9607)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M260.621 197.981L260.668 199.431C265.124 205.636 269.178 204.052 271.971 202.191C270.29 198.012 269.992 197.551 268.651 196.098C263.611 199.763 260.621 197.981 260.621 197.981Z",
    fill: "url(#paint11_linear_1507_9607)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M280.931 191.172L273.088 178.91C272.573 185.827 271.347 192.305 268.65 196.098C269.991 197.55 270.289 198.013 271.97 202.191C278.939 197.544 280.931 191.172 280.931 191.172Z",
    fill: "url(#paint12_linear_1507_9607)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M288.632 294.081C284.722 294.261 280.937 294.149 278.41 294.019C280.711 292.381 286.012 288.817 290.447 287.399L293.493 287.217C293.493 287.217 294.525 288.786 294.893 292.377C294.387 293.006 292.913 293.884 288.632 294.081Z",
    fill: "url(#paint13_linear_1507_9607)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M278.377 294.041C278.388 294.034 278.398 294.026 278.409 294.019C280.936 294.149 284.721 294.262 288.631 294.082C292.912 293.885 294.387 293.007 294.891 292.377C294.909 292.543 294.926 292.706 294.94 292.88C295.004 293.669 294.418 294.36 293.63 294.419C290.427 294.662 282.487 295.21 278.658 295.008C278.154 294.983 277.966 294.335 278.377 294.041Z",
    fill: "url(#paint14_linear_1507_9607)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M316.599 293.036C316.885 291.2 317.345 288.546 317.7 287.868C318.256 286.803 320.162 287.868 320.162 287.868C320.162 287.868 321.499 288.492 322.115 289.531C322.507 290.193 323.592 292.079 324.328 293.359C324.412 293.506 324.447 293.663 324.442 293.815L316.813 294.082C316.627 293.784 316.539 293.418 316.599 293.036Z",
    fill: "url(#paint15_linear_1507_9607)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M324.443 293.814C324.43 294.251 324.084 294.646 323.597 294.659L318.161 294.808C317.587 294.825 317.09 294.525 316.812 294.081L324.443 293.814Z",
    fill: "url(#paint16_linear_1507_9607)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M316.016 281.765C316.082 281.986 317.068 286.765 317.499 288.862C317.618 289.442 318.14 289.849 318.732 289.819C319.054 289.802 319.43 289.773 319.824 289.722C320.524 289.632 321.055 289.049 321.083 288.345C321.152 286.508 321.187 282.98 320.512 281.612C319.581 279.728 316.016 281.765 316.016 281.765Z",
    fill: "url(#paint17_linear_1507_9607)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.091 283.134C293.667 283.12 294.259 285.316 293.62 287.476C293.476 287.963 293.112 288.345 292.604 288.352C292.274 288.356 291.885 288.349 291.489 288.318C290.893 288.27 290.415 287.808 290.36 287.213L289.839 281.613L294.091 283.134Z",
    fill: "url(#paint18_linear_1507_9607)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M282.264 223.606C282.453 224.525 289.113 263.379 289.518 283.485C289.525 283.822 289.773 284.104 290.107 284.152C290.953 284.27 292.599 284.421 294.196 284.125C294.416 284.084 294.58 283.905 294.594 283.682C294.827 279.935 296.699 248.257 294.406 233.345C294.406 233.345 313.346 273.208 316.218 284.199C316.288 284.467 316.533 284.647 316.809 284.632C317.62 284.589 319.308 284.443 320.647 283.95C321.127 283.774 321.401 283.269 321.279 282.772C319.675 276.193 308.434 230.872 300.801 220.887L282.264 223.606Z",
    fill: "url(#paint19_linear_1507_9607)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M294.404 233.594C294.467 233.594 294.53 233.571 294.578 233.523C294.677 233.427 294.678 233.269 294.582 233.172L292.045 230.579C291.949 230.48 291.793 230.479 291.694 230.575C291.595 230.672 291.594 230.829 291.69 230.927L294.227 233.52C294.276 233.57 294.339 233.594 294.404 233.594Z",
    fill: "url(#paint20_linear_1507_9607)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M271.435 174.962C276.301 173.687 285.276 171.672 292.419 172.118C294.752 172.264 295.194 174.461 295.287 176.102C296.367 195.129 298.022 211.064 300.799 220.888C294.556 223.359 288.368 224.504 282.263 223.607C277.689 213.81 273.69 202.499 270.273 189.655C270.273 189.655 268.269 179.411 270.215 175.995C270.518 175.464 270.918 175.097 271.435 174.962Z",
    fill: "url(#paint21_linear_1507_9607)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M283.14 161.633C283.14 161.633 284.368 168.963 284.734 172.351C284.793 172.902 284.506 173.423 284.013 173.677C282.67 174.368 279.804 175.482 276.681 174.46C276.166 174.292 275.83 173.794 275.841 173.252L276.056 163.468L283.14 161.633Z",
    fill: "url(#paint22_linear_1507_9607)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M253.597 122.992C253.771 122.893 253.833 122.673 253.735 122.499L253.236 121.615L253.198 121.636L250.263 116.875C250.158 116.705 249.935 116.652 249.765 116.757L249.21 117.1C249.039 117.204 248.987 117.428 249.092 117.598L251.801 121.992C251.909 122.167 251.849 122.397 251.671 122.498L230.378 134.506C230.204 134.604 230.142 134.825 230.24 134.999L230.738 135.882L230.745 135.879L237.664 148.149C237.763 148.323 237.983 148.385 238.157 148.287L238.726 147.966C238.9 147.867 238.961 147.647 238.864 147.473L232.122 135.517C232.023 135.343 232.085 135.123 232.26 135.024L253.597 122.992Z",
    fill: "url(#paint23_linear_1507_9607)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M244.888 106.511L200.758 131.398L206.418 141.434L250.548 116.547L244.888 106.511Z",
    fill: "#43E084"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M283.404 233.262L280.139 234.915C280.053 234.958 279.949 234.924 279.906 234.838L235.618 147.352C235.575 147.266 235.609 147.161 235.695 147.119L238.959 145.466C239.045 145.423 239.15 145.457 239.193 145.542L283.48 233.029C283.523 233.115 283.49 233.219 283.404 233.262Z",
    fill: "url(#paint24_linear_1507_9607)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.418 141.435C207.454 140.85 207.017 138.113 205.443 135.321C203.868 132.529 201.752 130.739 200.716 131.323C199.68 131.907 200.116 134.644 201.691 137.437C203.266 140.229 205.382 142.019 206.418 141.435Z",
    fill: "#100C41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M250.259 116.759C251.295 116.175 250.858 113.437 249.284 110.645C247.709 107.853 245.593 106.063 244.556 106.647C243.52 107.231 243.957 109.969 245.532 112.761C247.107 115.553 249.223 117.343 250.259 116.759Z",
    fill: "#100C41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.908 198.205C259.6 197.738 259.522 197.159 259.688 196.624C260.008 195.586 260.678 194.063 261.799 194.399C263.466 194.901 263.689 199.022 263.689 199.022L263.246 201.667L263.803 202.987C262.7 202.455 261.345 200.549 259.908 198.205Z",
    fill: "url(#paint25_linear_1507_9607)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M298.516 207.514C299.198 206.558 299.881 205.512 300.556 204.356C307.229 192.927 294.99 175.424 294.99 175.424L291.261 186.527C296.775 192.678 294.459 198.611 292.583 203.535C290.126 209.981 279.503 215.446 279.503 215.446L281.527 217.943C281.527 217.943 292.448 216.021 298.516 207.514Z",
    fill: "url(#paint26_linear_1507_9607)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M302.711 192.875C302.573 184.002 295.525 174.575 294.238 172.916C294.146 172.798 293.964 172.822 293.903 172.958L291.261 186.528C292.382 189.15 292.155 190.801 293.275 193.163C296.307 192.738 299.12 192.718 302.11 193.365C302.422 193.433 302.716 193.195 302.711 192.875Z",
    fill: "url(#paint27_linear_1507_9607)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M279.503 215.448C278.883 215.134 274.02 215.842 274.766 216.511C276.073 217.684 276.129 218.572 274.755 219.669C274.077 220.211 272.518 221.033 272.092 219.768C271.973 219.412 271.957 218.952 271.618 218.789C271.367 218.67 270.66 219.526 270.618 219.801C270.382 221.341 271.611 222.621 272.967 223.131C273.624 223.38 274.325 223.485 275.02 223.589C275.406 223.647 276.37 223.791 276.456 223.753C276.557 223.709 276.617 223.607 276.691 223.526C277.007 223.174 278.703 221.745 279.073 221.268C279.272 221.01 281.813 217.806 281.685 217.5C281.684 217.498 280.029 215.714 279.503 215.448Z",
    fill: "url(#paint28_linear_1507_9607)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M274.632 153.824C274.632 153.824 270.704 161.219 271.208 164.206C271.711 167.194 276.58 166.979 280.831 164.553L283.803 156.568L274.632 153.824Z",
    fill: "url(#paint29_linear_1507_9607)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.644 160.632C280.471 160.555 280.407 160.344 280.51 160.186C280.825 159.704 281.415 158.724 281.603 157.865C281.603 157.865 282.309 157.413 279.805 156.813C277.301 156.213 273.568 155.283 272.783 153.153C272.017 151.074 274.028 145.85 277.235 150.013C277.357 150.172 277.596 150.176 277.718 150.017C278.243 149.332 279.625 147.912 281.545 148.773C283.341 149.579 283.543 150.896 283.519 151.559C283.512 151.754 283.686 151.906 283.878 151.87C284.786 151.697 286.966 151.548 287.983 153.784C288.82 155.625 288.276 156.667 287.78 157.177C287.618 157.342 287.689 157.614 287.91 157.682C288.507 157.865 289.277 158.37 289.2 159.768C289.094 161.701 286.933 161.531 286.317 161.443C286.216 161.429 286.114 161.462 286.047 161.538C285.519 162.121 283.143 164.601 280.569 164.9C280.347 164.925 280.174 164.706 280.247 164.494L281.36 161.257C281.413 161.106 281.341 160.942 281.195 160.878L280.644 160.632Z",
    fill: "url(#paint30_linear_1507_9607)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M280.196 161.091C280.196 161.091 282.994 159.172 283.198 160.788C283.402 162.405 280.679 163.129 279.33 162.527L280.196 161.091Z",
    fill: "url(#paint31_linear_1507_9607)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M271.795 294.337C263.203 297.206 254.857 297.209 246.807 294.587C244.773 293.924 243.394 292.028 243.394 289.888V250.463C253.285 252.64 263.653 252.75 274.575 250.463V290.498C274.576 292.244 273.451 293.783 271.795 294.337Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M258.985 253.283C267.596 253.283 274.576 251.88 274.576 250.149C274.576 248.419 267.596 247.016 258.985 247.016C250.375 247.016 243.395 248.419 243.395 250.149C243.395 251.88 250.375 253.283 258.985 253.283Z",
    fill: "#7D97F4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M274.576 280.821C264.182 284.436 253.788 284.436 243.395 280.821V265.094C253.882 267.679 264.281 267.811 274.576 265.094V280.821Z",
    fill: "url(#paint32_linear_1507_9607)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M245.067 254.049C245.401 255.297 246.825 256.139 248.08 255.83C248.959 255.613 249.711 254.924 250.617 254.909C251.646 254.892 252.467 255.74 253.067 256.576C254.157 258.094 254.985 259.8 255.506 261.594C255.68 262.191 255.833 262.827 256.252 263.286C257.151 264.27 258.85 263.955 259.849 263.073C260.847 262.191 261.39 260.918 262.132 259.812C262.875 258.705 264.015 257.673 265.344 257.753C265.789 257.78 266.221 257.933 266.666 257.951C267.653 257.993 268.623 257.294 268.896 256.345C268.98 256.054 269.006 255.741 269.156 255.478C269.606 254.69 270.798 254.614 271.414 253.975C271.805 253.57 271.935 252.981 272.391 252.582C272.563 252.431 273.745 251.943 273.77 251.867C273.977 251.232 273.317 250.658 272.706 250.385C269.121 248.789 265.024 250.38 261.137 250.924C257.319 251.459 253.666 250.588 249.885 250.621C247.801 250.64 244.288 251.142 245.067 254.049Z",
    fill: "url(#paint33_linear_1507_9607)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M259.165 253.373C267.775 253.373 274.756 251.97 274.756 250.239C274.756 248.508 267.775 247.105 259.165 247.105C250.554 247.105 243.574 248.508 243.574 250.239C243.574 251.97 250.554 253.373 259.165 253.373Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M258.75 252.134C265.839 252.134 271.585 251.285 271.585 250.239C271.585 249.192 265.839 248.344 258.75 248.344C251.662 248.344 245.915 249.192 245.915 250.239C245.915 251.285 251.662 252.134 258.75 252.134Z",
    fill: "url(#paint34_linear_1507_9607)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1485 291.258H4.86636C2.17919 291.258 0 289.079 0 286.392V205.013C0 202.33 2.17107 200.153 4.8536 200.146L89.8107 199.918C92.513 199.911 94.7049 202.108 94.6898 204.81L94.016 286.416C94.0009 289.095 91.8264 291.258 89.1485 291.258Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0184 206.149L9.65603 206.612C6.93175 206.629 4.73632 208.848 4.74908 211.573L5.27445 280.017C5.28721 282.7 7.43973 284.882 10.1223 284.931L83.3461 286.267C86.0808 286.317 88.3354 284.134 88.3736 281.4L89.9857 211.155C90.0251 208.389 87.7845 206.131 85.0184 206.149Z",
    fill: "#77AD8D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.9544 212.495V213.015C81.9544 213.83 81.2934 214.492 80.4769 214.492H22.4111C21.5958 214.492 20.9336 213.831 20.9336 213.015V212.495C20.9336 211.68 21.5947 211.018 22.4111 211.018H80.4769C81.2934 211.018 81.9544 211.679 81.9544 212.495Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.4762 219.031C75.4345 219.805 74.8024 220.414 74.0277 220.429L23.2464 221.354C22.4207 221.369 21.7422 220.704 21.7422 219.878V219.757C21.7422 218.95 22.3893 218.294 23.1954 218.28L73.9767 217.475C74.8337 217.461 75.5215 218.175 75.4762 219.031Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6589 282.395C80.6415 282.395 80.6252 282.395 80.6078 282.395L11.9222 281.57C10.7925 281.556 9.73716 281.103 8.95085 280.291C8.16453 279.48 7.74354 278.411 7.76441 277.281L9.53189 228.949C9.55276 227.837 10.0109 226.789 10.8215 226.01C11.6322 225.23 12.7143 224.815 13.8218 224.835L82.3869 226.17C84.703 226.215 86.5539 228.137 86.5133 230.453C86.5133 230.456 86.5133 230.461 86.5133 230.464L84.8653 278.274C84.8259 280.551 82.9436 282.395 80.6589 282.395ZM13.7395 226.233C13.01 226.233 12.3211 226.511 11.7934 227.018C11.253 227.539 10.9468 228.239 10.9329 228.989L9.16541 277.321C9.15149 278.062 9.43214 278.775 9.95636 279.317C10.4817 279.858 11.1857 280.161 11.9396 280.17L80.6241 280.995C80.6357 280.995 80.6461 280.995 80.6577 280.995C82.1816 280.995 83.4377 279.764 83.4655 278.237L85.1135 230.421C85.1379 228.879 83.9039 227.6 82.3602 227.569L13.7952 226.234C13.7766 226.234 13.7581 226.233 13.7395 226.233Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9248 235.559H10.1214C9.7352 235.559 9.4209 235.246 9.4209 234.859C9.4209 234.471 9.73404 234.158 10.1214 234.158H84.9248C85.311 234.158 85.6253 234.471 85.6253 234.859C85.6253 235.246 85.311 235.559 84.9248 235.559Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8137 96.0295C70.6223 96.2023 70.3266 96.1907 70.1492 96.0028C69.7143 95.5424 69.2805 95.0634 68.8584 94.5821C68.6855 94.3838 68.7273 94.0834 68.9036 93.9106C69.1019 93.7378 69.4023 93.7575 69.5751 93.9558C69.9891 94.429 70.4147 94.8987 70.8415 95.351C71.0225 95.5424 71.0132 95.8427 70.8218 96.0237C70.8184 96.0248 70.816 96.0272 70.8137 96.0295Z",
    fill: "url(#paint35_linear_1507_9607)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9802 82.7913C75.0997 83.0174 75.3502 83.1427 75.603 83.1044L82.8179 81.9864C85.055 84.5587 87.719 86.7936 90.7471 88.5657L90.9837 95.8583C90.9919 96.1146 91.1612 96.3361 91.4059 96.4115L99.7736 98.9954C100.018 99.0708 100.284 98.9827 100.435 98.7762L104.743 92.8881C108.243 93.1317 111.703 92.7896 115.002 91.9267L120.33 96.9183C120.517 97.0934 120.794 97.1306 121.02 97.0111L128.764 92.9218C128.99 92.8023 129.116 92.5518 129.077 92.299L127.959 85.0841C130.532 82.8469 132.766 80.183 134.539 77.1548L141.831 76.9182C142.087 76.9101 142.309 76.7408 142.384 76.4961L144.968 68.1284C145.044 67.8837 144.956 67.6181 144.749 67.4674L138.861 63.1588C139.105 59.6587 138.762 56.1991 137.9 52.8996L142.892 47.5717C143.067 47.3849 143.105 47.1077 142.985 46.8816L138.893 39.139C138.774 38.9129 138.523 38.7876 138.271 38.8259L131.056 39.9439C128.819 37.3716 126.155 35.1367 123.127 33.3646L122.89 26.072C122.882 25.8169 122.712 25.5942 122.468 25.5188L114.1 22.9348C113.855 22.8595 113.59 22.9476 113.439 23.154L109.131 29.0421C105.63 28.7986 102.171 29.1407 98.8713 30.0036L93.5445 25.012C93.3578 24.8369 93.0806 24.7997 92.8544 24.9192L85.1107 29.0085C84.8846 29.128 84.7593 29.3773 84.7976 29.6313L85.9156 36.8462C83.3432 39.0834 81.1084 41.7473 79.3363 44.7755L72.0437 45.0121C71.7885 45.0202 71.5659 45.1895 71.4905 45.4342L68.9065 53.8019C68.8311 54.0466 68.9193 54.3122 69.1257 54.4629L75.0138 58.7715C74.7703 62.2716 75.1136 65.7312 75.9753 69.0307L70.9837 74.3587C70.8085 74.5454 70.7714 74.8226 70.8909 75.0487L74.9802 82.7913Z",
    fill: "url(#paint36_linear_1507_9607)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M112.623 67.2665C112.621 67.2688 112.62 67.2699 112.618 67.2723C110.933 68.7892 108.758 69.5605 106.493 69.441C104.228 69.3227 102.145 68.3288 100.628 66.6448C99.1099 64.9597 98.3398 62.784 98.4581 60.5201C98.7029 55.8451 102.705 52.2406 107.38 52.4865C109.645 52.6048 111.728 53.5987 113.245 55.2827C114.763 56.9678 115.533 59.1435 115.415 61.4074C115.296 63.6689 114.305 65.7495 112.623 67.2665ZM102.205 55.7199C100.807 56.9817 99.9821 58.7132 99.8835 60.5944C99.7849 62.479 100.425 64.2882 101.688 65.6892C102.95 67.0913 104.684 67.9171 106.567 68.0157C108.451 68.1143 110.261 67.4729 111.662 66.2111C111.663 66.2099 111.666 66.2076 111.667 66.2065C113.065 64.9446 113.89 63.2131 113.989 61.332C114.087 59.4485 113.447 57.6381 112.184 56.2371C110.922 54.835 109.188 54.0092 107.305 53.9107C105.421 53.8121 103.611 54.4534 102.21 55.7153C102.209 55.7164 102.208 55.7187 102.205 55.7199Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.751 77.0569C116.219 82.0485 108.27 84.0909 100.648 81.7377C99.1585 81.2773 97.7204 80.6615 96.3739 79.9041L97.0733 78.6609C98.3328 79.3683 99.6769 79.9447 101.069 80.375C109.52 82.9845 118.402 79.8125 123.431 73.1149C123.44 73.1021 123.45 73.0894 123.459 73.0778C123.468 73.065 123.478 73.0523 123.488 73.0395C124.834 71.2303 125.899 69.1671 126.602 66.8928C128.212 61.682 127.696 56.1569 125.149 51.3334C124.342 49.8049 123.362 48.405 122.233 47.1548C119.8 44.4595 116.679 42.4578 113.12 41.3583C102.363 38.0356 90.908 44.0849 87.5864 54.8406C86.4939 58.3778 86.3803 62.1366 87.257 65.711L85.8711 66.0508C84.9329 62.2259 85.0546 58.2039 86.2225 54.4196C89.7784 42.9124 102.032 36.4398 113.541 39.9945C117.349 41.1704 120.688 43.3114 123.291 46.1957C124.498 47.5341 125.548 49.0313 126.411 50.6666C129.135 55.8263 129.688 61.7388 127.966 67.3138C126.764 71.199 124.571 74.5112 121.751 77.0569Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M150.112 84.3457C150.024 84.4235 149.995 84.5499 150.04 84.6589L151.326 87.7694C150.417 89.0521 149.706 90.4878 149.242 92.0373L146.002 92.9373C145.888 92.9686 145.807 93.0695 145.8 93.1866L145.553 97.2156C145.546 97.3339 145.615 97.4429 145.724 97.4882L148.831 98.7766C149.102 100.371 149.632 101.884 150.378 103.267L148.722 106.197C148.664 106.3 148.678 106.428 148.755 106.516L151.43 109.539C151.507 109.627 151.634 109.656 151.743 109.611L154.853 108.325C156.136 109.234 157.572 109.944 159.121 110.409L160.021 113.649C160.053 113.763 160.153 113.844 160.271 113.851L164.3 114.098C164.418 114.105 164.527 114.037 164.572 113.928L165.861 110.821C167.455 110.549 168.968 110.019 170.351 109.274L173.281 110.93C173.384 110.988 173.512 110.974 173.6 110.896L176.623 108.222C176.711 108.144 176.74 108.018 176.695 107.909L175.409 104.798C176.318 103.515 177.029 102.08 177.493 100.53L180.733 99.6302C180.847 99.5989 180.928 99.498 180.935 99.3809L181.182 95.3519C181.189 95.2336 181.121 95.1246 181.012 95.0793L177.905 93.7908C177.633 92.1962 177.103 90.6838 176.358 89.3002L178.014 86.3707C178.072 86.2675 178.058 86.1399 177.98 86.0518L175.306 83.0283C175.228 82.9401 175.102 82.9111 174.993 82.9564L171.882 84.2425C170.599 83.3333 169.164 82.6223 167.614 82.1584L166.714 78.9181C166.683 78.8044 166.582 78.7232 166.465 78.7163L162.436 78.4692C162.318 78.4623 162.209 78.5307 162.163 78.6397L160.875 81.7467C159.28 82.0181 157.768 82.5481 156.384 83.2938L153.455 81.6377C153.351 81.5797 153.224 81.5936 153.136 81.6713L150.112 84.3457Z",
    fill: "#313131"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M161.036 99.7038C161.035 99.7027 161.034 99.7026 161.033 99.7015C160.12 99.0787 159.504 98.1358 159.3 97.0491C159.096 95.9624 159.327 94.8618 159.949 93.9491C160.573 93.0363 161.515 92.4205 162.602 92.2164C164.845 91.7942 167.012 93.2753 167.435 95.5182C167.639 96.6049 167.408 97.7055 166.785 98.6183C166.161 99.531 165.219 100.147 164.133 100.351C163.048 100.556 161.948 100.325 161.036 99.7038ZM165.073 93.7821C164.433 93.3448 163.627 93.1523 162.806 93.3066C162.01 93.4562 161.321 93.9073 160.864 94.5754C160.408 95.2434 160.238 96.0506 160.389 96.845C160.539 97.6406 160.99 98.3295 161.658 98.7864C161.659 98.7864 161.659 98.7876 161.66 98.7876C162.328 99.2434 163.133 99.4116 163.927 99.2619C164.723 99.1123 165.412 98.6623 165.869 97.9932C166.326 97.3251 166.495 96.518 166.344 95.7235C166.191 94.9012 165.716 94.2193 165.073 93.7821Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M157.645 104.858C154.743 102.88 152.923 99.4663 153.153 95.7145C153.193 95.065 153.294 94.4202 153.453 93.7939C153.474 93.7139 153.494 93.6327 153.518 93.5539L154.585 93.8531C154.409 94.4782 154.3 95.1277 154.26 95.7818C154.216 96.5078 154.258 97.2199 154.376 97.9064C154.376 97.9088 154.377 97.9099 154.377 97.9122C154.377 97.9157 154.378 97.9192 154.378 97.9227C154.912 100.982 156.973 103.561 159.787 104.778C160.516 105.093 161.295 105.318 162.11 105.436C162.137 105.439 162.162 105.444 162.189 105.447C162.21 105.45 162.232 105.453 162.253 105.455C162.307 105.462 162.362 105.469 162.418 105.475C162.566 105.491 162.717 105.504 162.868 105.513C165.317 105.664 167.678 104.851 169.517 103.225C170.099 102.71 170.607 102.133 171.033 101.506C171.953 100.156 172.497 98.5791 172.599 96.9056C172.749 94.4562 171.937 92.0949 170.311 90.2567C168.686 88.4184 166.441 87.3236 163.991 87.174C162.329 87.072 160.673 87.421 159.204 88.1842L158.694 87.1995C160.342 86.3436 162.197 85.9516 164.06 86.0664C166.805 86.2346 169.319 87.4616 171.141 89.5214C172.963 91.5811 173.874 94.2277 173.706 96.9717C173.591 98.847 172.982 100.614 171.951 102.128C171.473 102.83 170.904 103.477 170.251 104.054C168.191 105.876 165.544 106.787 162.8 106.619C160.887 106.503 159.125 105.867 157.645 104.858Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M214.885 41.4946C214.787 41.4343 214.718 41.3276 214.712 41.2035C214.69 40.7245 214.657 40.2456 214.615 39.7782C214.596 39.5799 214.744 39.4036 214.942 39.3862C215.14 39.3688 215.317 39.5149 215.334 39.7132C215.377 40.191 215.41 40.6805 215.434 41.1687C215.443 41.3682 215.289 41.5375 215.09 41.5468C215.015 41.5514 214.944 41.5317 214.885 41.4946Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M162.311 72.6052C161.592 72.1656 160.881 71.6936 160.198 71.2042C160.036 71.0882 159.998 70.8621 160.114 70.7009C160.23 70.5397 160.454 70.4991 160.618 70.6174C161.403 71.181 162.225 71.7168 163.06 72.2143C163.061 72.2155 163.062 72.2155 163.064 72.2167C163.232 72.3199 163.286 72.5391 163.185 72.7096C163.083 72.8812 162.862 72.9369 162.69 72.8348C162.565 72.7594 162.437 72.6829 162.311 72.6052ZM166.966 74.9862C166.817 74.8946 166.752 74.7055 166.821 74.5385C166.898 74.3541 167.11 74.2683 167.294 74.3448C168.187 74.7183 169.108 75.0593 170.031 75.3573C170.223 75.4176 170.326 75.6217 170.265 75.8119C170.203 76.001 170 76.1065 169.81 76.045C168.867 75.7412 167.928 75.3933 167.016 75.0117C166.999 75.0047 166.981 74.9955 166.966 74.9862ZM174.379 77.1642C174.256 77.0888 174.186 76.9439 174.212 76.7931C174.247 76.5971 174.434 76.466 174.631 76.5008C175.587 76.6702 176.56 76.7989 177.522 76.8859C177.721 76.9033 177.868 77.0795 177.849 77.2779C177.832 77.4762 177.656 77.6235 177.457 77.6049C176.474 77.5168 175.481 77.3834 174.505 77.2118C174.459 77.2036 174.418 77.1874 174.379 77.1642ZM182.088 77.6501C181.99 77.5898 181.921 77.4843 181.916 77.3602C181.906 77.1607 182.059 76.9914 182.259 76.9821C183.225 76.9346 184.201 76.843 185.163 76.7119C185.36 76.6852 185.543 76.8232 185.57 77.0204C185.597 77.2176 185.459 77.3996 185.261 77.4275C184.28 77.562 183.282 77.6548 182.296 77.7035C182.219 77.7058 182.149 77.6861 182.088 77.6501ZM189.709 76.3999C189.635 76.3547 189.576 76.2816 189.55 76.19C189.496 75.9987 189.608 75.798 189.8 75.7447C190.731 75.4826 191.663 75.1752 192.57 74.8343C192.757 74.7647 192.966 74.8586 193.035 75.0453C193.105 75.232 193.011 75.4408 192.824 75.5104C191.898 75.8595 190.945 76.1726 189.994 76.4405C189.895 76.4684 189.791 76.451 189.709 76.3999ZM196.864 73.4878C196.812 73.4553 196.766 73.4101 196.735 73.3521C196.64 73.177 196.705 72.9578 196.88 72.8627C197.732 72.3988 198.574 71.8943 199.382 71.3619C199.549 71.2517 199.772 71.2981 199.881 71.4651C199.992 71.631 199.945 71.856 199.779 71.965C198.955 72.5089 198.095 73.0239 197.226 73.4982C197.107 73.5608 196.97 73.5527 196.864 73.4878ZM203.199 69.0656C203.169 69.0471 203.142 69.0238 203.116 68.996C202.985 68.8464 202.999 68.6179 203.148 68.4869C203.877 67.8467 204.585 67.1682 205.256 66.4689C205.394 66.3251 205.621 66.3204 205.766 66.4585C205.91 66.5965 205.914 66.8249 205.776 66.9688C205.092 67.6832 204.367 68.3755 203.625 69.0296C203.505 69.1352 203.331 69.1456 203.199 69.0656ZM208.395 63.3457C208.387 63.341 208.38 63.3352 208.372 63.3306C208.211 63.2134 208.174 62.9885 208.291 62.8261C208.792 62.1314 209.272 61.41 209.717 60.6817C209.776 60.5843 209.836 60.4868 209.895 60.3894C209.997 60.2178 210.218 60.1621 210.39 60.2642C210.391 60.2653 210.392 60.2653 210.394 60.2665C210.562 60.3697 210.617 60.5901 210.515 60.7594C210.455 60.8591 210.395 60.9589 210.334 61.0586C209.879 61.8032 209.389 62.5396 208.878 63.2482C208.765 63.4037 208.555 63.4431 208.395 63.3457ZM212.18 56.6109C212.03 56.5193 211.965 56.3291 212.036 56.1633C212.411 55.2726 212.755 54.3529 213.055 53.4285C213.117 53.2383 213.321 53.1351 213.51 53.1966C213.699 53.2604 213.803 53.4622 213.742 53.6512C213.434 54.5941 213.084 55.5335 212.7 56.4428C212.623 56.6272 212.411 56.713 212.227 56.6353C212.212 56.6283 212.196 56.6202 212.18 56.6109ZM214.378 49.2024C214.255 49.127 214.185 48.982 214.211 48.8301C214.383 47.8733 214.515 46.9014 214.605 45.9388C214.623 45.7405 214.799 45.5944 214.998 45.6129C215.196 45.6315 215.342 45.8066 215.324 46.0061C215.233 46.9884 215.097 47.9811 214.922 48.9577C214.888 49.1537 214.7 49.2847 214.504 49.2499C214.458 49.2418 214.417 49.2256 214.378 49.2024Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M156.52 68.1525C156.498 68.1398 156.477 68.1235 156.459 68.105C156.104 67.7663 155.756 67.4196 155.425 67.0763C155.287 66.9325 155.291 66.704 155.435 66.566C155.578 66.4268 155.807 66.4326 155.945 66.5752C156.27 66.9116 156.609 67.2514 156.957 67.5831C157.101 67.7211 157.107 67.9496 156.969 68.0934C156.849 68.2198 156.662 68.2395 156.52 68.1525Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M145.799 43.2892C145.696 43.2254 145.626 43.1129 145.626 42.9818C145.624 42.5005 145.633 42.01 145.651 41.5229C145.658 41.3234 145.826 41.168 146.025 41.1761C146.225 41.1842 146.38 41.3512 146.372 41.5507C146.353 42.0273 146.345 42.5086 146.348 42.9795C146.349 43.179 146.188 43.3414 145.988 43.3425C145.919 43.3425 145.854 43.3228 145.799 43.2892Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M146.324 37.1585C146.201 37.0831 146.13 36.9381 146.157 36.7873C146.325 35.8317 146.537 34.8679 146.787 33.9251C146.838 33.7325 147.035 33.6166 147.229 33.6676C147.421 33.7198 147.537 33.9158 147.486 34.1095C147.242 35.0338 147.035 35.9778 146.869 36.9138C146.834 37.1098 146.648 37.2408 146.45 37.206C146.404 37.1979 146.361 37.1817 146.324 37.1585ZM148.452 29.8589C148.304 29.7673 148.239 29.5794 148.307 29.4124C148.681 28.5113 149.096 27.6171 149.542 26.7543C149.634 26.5768 149.852 26.5084 150.029 26.6C150.209 26.6928 150.276 26.9097 150.185 27.0871C149.748 27.9326 149.341 28.8082 148.975 29.6908C148.899 29.8752 148.688 29.9622 148.503 29.8856C148.485 29.8775 148.468 29.8694 148.452 29.8589ZM152.123 23.2008C152.116 23.1961 152.109 23.1926 152.103 23.188C151.941 23.0732 151.901 22.847 152.016 22.6847C152.577 21.8902 153.179 21.1097 153.807 20.364C153.935 20.2109 154.163 20.1923 154.316 20.3199C154.469 20.4486 154.489 20.676 154.36 20.829C153.745 21.5597 153.156 22.324 152.606 23.1022C152.495 23.2564 152.283 23.2993 152.123 23.2008ZM157.167 17.5121C157.138 17.4947 157.111 17.4727 157.087 17.446C156.953 17.2976 156.965 17.0703 157.112 16.9357C157.833 16.2828 158.593 15.653 159.368 15.0639C159.527 14.9432 159.753 14.9734 159.873 15.1323C159.994 15.2912 159.964 15.5173 159.805 15.6379C159.047 16.2155 158.303 16.8325 157.596 17.4715C157.476 17.5817 157.3 17.5933 157.167 17.5121ZM163.332 13.0644C163.281 13.0331 163.238 12.9902 163.207 12.9345C163.108 12.7606 163.17 12.5402 163.342 12.4428C164.189 11.9627 165.067 11.5138 165.951 11.1056C166.132 11.0221 166.346 11.101 166.43 11.283C166.513 11.464 166.434 11.6785 166.253 11.762C165.387 12.161 164.528 12.6017 163.698 13.0714C163.58 13.1375 163.44 13.1305 163.332 13.0644ZM170.316 10.0641C170.243 10.0201 170.186 9.94932 170.159 9.86118C170.101 9.66982 170.209 9.46802 170.399 9.41003C171.331 9.12589 172.285 8.87886 173.236 8.67475C173.431 8.63299 173.624 8.75708 173.665 8.95192C173.707 9.14676 173.583 9.33929 173.388 9.38104C172.458 9.58052 171.523 9.82291 170.611 10.1013C170.506 10.1337 170.401 10.1163 170.316 10.0641ZM177.784 8.6643C177.687 8.60516 177.621 8.5031 177.612 8.38248C177.597 8.18416 177.747 8.0102 177.945 7.99512C178.917 7.92206 179.903 7.89075 180.874 7.90003C181.074 7.90235 181.234 8.06587 181.232 8.26419C181.229 8.46366 181.066 8.62371 180.866 8.62139C179.914 8.61212 178.949 8.64343 177.998 8.71417C177.921 8.72229 177.846 8.70258 177.784 8.6643ZM185.379 8.94033C185.259 8.86726 185.189 8.72693 185.21 8.57964C185.239 8.38249 185.423 8.24563 185.62 8.27579C186.58 8.41844 187.549 8.60284 188.499 8.82551C188.694 8.86958 188.813 9.06558 188.768 9.25926C188.723 9.45294 188.528 9.57356 188.334 9.52833C187.403 9.31029 186.454 9.12937 185.515 8.9902C185.465 8.98208 185.42 8.96584 185.379 8.94033ZM192.733 10.8655C192.587 10.7762 192.521 10.5941 192.585 10.4283C192.655 10.2416 192.864 10.1488 193.051 10.2195C193.963 10.5686 194.868 10.9595 195.743 11.3805C195.921 11.4698 195.998 11.6832 195.911 11.8629C195.824 12.0427 195.608 12.1181 195.428 12.0311C194.572 11.6182 193.685 11.2355 192.792 10.8945C192.772 10.8876 192.752 10.8771 192.733 10.8655ZM201.839 16.0543C201.827 16.0462 201.815 16.0381 201.802 16.0288C201.055 15.4361 200.274 14.8679 199.48 14.3402C199.315 14.23 199.269 14.0062 199.38 13.8392C199.49 13.6733 199.712 13.6234 199.881 13.7383C200.691 14.2764 201.488 14.8563 202.251 15.4628C202.408 15.5869 202.433 15.8142 202.309 15.9696C202.195 16.1146 201.993 16.1471 201.839 16.0543Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M206.309 20.3076C206.278 20.289 206.251 20.2658 206.225 20.238C205.91 19.8785 205.585 19.5247 205.26 19.1849C205.122 19.0411 205.128 18.8126 205.272 18.6746C205.417 18.5366 205.644 18.5413 205.782 18.6862C206.114 19.033 206.445 19.3948 206.767 19.7613C206.898 19.9109 206.884 20.1394 206.734 20.2705C206.614 20.3772 206.441 20.3876 206.309 20.3076Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M202.532 27.9467C202.449 27.7901 202.276 27.7043 202.102 27.731L197.116 28.5162C195.564 26.7417 193.719 25.2004 191.623 23.9803L191.447 18.9389C191.441 18.7626 191.323 18.6083 191.154 18.5573L185.364 16.784C185.195 16.7318 185.012 16.7933 184.907 16.9359L181.938 21.0137C179.518 20.8513 177.126 21.0937 174.847 21.6956L171.156 18.2534C171.026 18.1328 170.835 18.1073 170.678 18.1908L165.331 21.0311C165.174 21.1146 165.088 21.2874 165.115 21.4613L165.9 26.4471C164.125 27.9989 162.584 29.8441 161.364 31.9398L156.323 32.1161C156.146 32.1219 155.992 32.2402 155.941 32.4095L154.168 38.199C154.116 38.3683 154.177 38.5516 154.32 38.6559L158.397 41.6249C158.235 44.0454 158.477 46.4368 159.079 48.7157L155.636 52.4072C155.515 52.5371 155.49 52.7285 155.573 52.8851L158.413 58.2327C158.496 58.3893 158.669 58.4751 158.843 58.4484L163.829 57.6633C165.379 59.4377 167.226 60.979 169.321 62.1991L169.496 67.2406C169.502 67.4169 169.62 67.5711 169.79 67.6221L175.579 69.3954C175.749 69.4476 175.932 69.3861 176.036 69.2423L179.005 65.1646C181.426 65.327 183.817 65.0846 186.096 64.4827L189.788 67.9248C189.917 68.0454 190.109 68.071 190.265 67.9875L195.613 65.1484C195.77 65.0649 195.855 64.8921 195.829 64.7181L195.044 59.7323C196.818 58.1805 198.359 56.3353 199.579 54.2397L204.621 54.0645C204.797 54.0587 204.951 53.9404 205.002 53.7711L206.776 47.9816C206.828 47.8123 206.766 47.629 206.624 47.5246L202.546 44.5557C202.708 42.1352 202.466 39.7438 201.864 37.4649L205.306 33.7733C205.427 33.6435 205.452 33.4521 205.369 33.2955L202.532 27.9467Z",
    fill: "#313131"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.39 48.143C176.911 47.8496 176.471 47.4866 176.084 47.0586C175.024 45.8861 174.482 44.3715 174.562 42.793C174.641 41.2146 175.33 39.7614 176.503 38.7002C177.675 37.6391 179.19 37.0986 180.768 37.1775C182.347 37.2563 183.801 37.9452 184.861 39.1178C185.921 40.2903 186.463 41.8049 186.383 43.3834C186.304 44.9618 185.615 46.415 184.442 47.4762C183.27 48.5373 181.755 49.0778 180.177 48.9989C179.175 48.9491 178.224 48.6533 177.39 48.143ZM182.992 38.9589C182.311 38.5425 181.534 38.3013 180.714 38.2595C179.424 38.1946 178.187 38.6365 177.229 39.5028C176.271 40.3691 175.708 41.5567 175.644 42.8464C175.58 44.136 176.021 45.3735 176.888 46.3315C177.754 47.2894 178.942 47.8519 180.231 47.9157C181.521 47.9806 182.758 47.5388 183.716 46.6724C184.674 45.8061 185.237 44.6185 185.301 43.3288C185.366 42.0392 184.924 40.8017 184.057 39.8438C183.742 39.4958 183.382 39.1989 182.992 38.9589Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M172.46 56.0847C166.703 52.5637 163.813 45.4636 165.879 38.7196C166.26 37.4752 166.788 36.3154 167.438 35.2531C170.959 29.496 178.06 26.6047 184.804 28.6691C184.924 28.7062 185.046 28.7457 185.166 28.7851C185.976 29.0553 186.763 29.3928 187.51 29.7918C187.597 29.8382 187.684 29.8857 187.771 29.9333L187.242 30.8796C186.374 30.3949 185.447 29.9994 184.486 29.7048C184.477 29.7013 184.467 29.699 184.459 29.6967C177.05 27.4433 169.184 31.6288 166.916 39.0362C164.644 46.4529 168.829 54.3346 176.247 56.6066C182.509 58.5248 189.102 55.84 192.371 50.4935C192.974 49.5066 193.465 48.4303 193.819 47.2752C194.566 44.8374 194.637 42.2464 194.029 39.7843L195.08 39.5233C195.738 42.1757 195.66 44.9649 194.855 47.5918C194.474 48.8362 193.946 49.996 193.297 51.0583C189.776 56.8154 182.675 59.7066 175.93 57.6423C174.684 57.2619 173.523 56.7342 172.46 56.0847Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1517 113.549L90.7664 116.888C85.9603 116.426 82.256 114.93 79.4111 113.034C81.1229 108.776 82.8614 106.251 84.2276 104.771C88.7031 111.063 94.1517 113.549 94.1517 113.549Z",
    fill: "url(#paint37_linear_1507_9607)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5859 101.055L78.5767 88.5625C79.1009 95.6092 81.4819 100.907 84.2294 104.77C82.8632 106.25 81.1247 108.775 79.4129 113.032C72.3128 108.3 70.5859 101.055 70.5859 101.055Z",
    fill: "url(#paint38_linear_1507_9607)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0885 199.794C66.0722 199.977 69.9285 199.863 72.5031 199.73C70.1592 198.061 64.7582 194.431 60.2398 192.986L57.1374 192.801C57.1374 192.801 56.0867 194.399 55.7109 198.058C56.2247 198.699 57.7278 199.594 62.0885 199.794Z",
    fill: "url(#paint39_linear_1507_9607)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5345 199.754C72.524 199.747 72.5124 199.739 72.502 199.731C69.9273 199.863 66.0711 199.978 62.0873 199.795C57.7266 199.594 56.2236 198.7 55.7098 198.059C55.6924 198.227 55.675 198.395 55.6611 198.572C55.5961 199.375 56.1923 200.08 56.996 200.14C60.2584 200.387 68.3477 200.945 72.2491 200.741C72.7629 200.714 72.9543 200.053 72.5345 199.754Z",
    fill: "url(#paint40_linear_1507_9607)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5948 198.73C33.3026 196.859 32.8352 194.156 32.4734 193.464C31.9062 192.38 29.9648 193.464 29.9648 193.464C29.9648 193.464 28.6021 194.1 27.9746 195.159C27.5745 195.834 26.4693 197.754 25.7201 199.059C25.6342 199.209 25.5983 199.369 25.6029 199.523L33.3757 199.796C33.5659 199.49 33.6552 199.119 33.5948 198.73Z",
    fill: "url(#paint41_linear_1507_9607)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6035 199.523C25.6163 199.968 25.9688 200.37 26.4652 200.384L32.0031 200.536C32.5876 200.552 33.0944 200.248 33.3774 199.795L25.6035 199.523Z",
    fill: "url(#paint42_linear_1507_9607)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1894 187.248C34.1222 187.472 33.1178 192.342 32.6783 194.478C32.5565 195.069 32.0242 195.484 31.4223 195.454C31.0929 195.437 30.7102 195.407 30.3089 195.356C29.5968 195.265 29.0552 194.67 29.0274 193.952C28.9566 192.08 28.9207 188.486 29.6084 187.093C30.5571 185.171 34.1894 187.248 34.1894 187.248Z",
    fill: "url(#paint43_linear_1507_9607)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5264 188.643C56.9566 188.629 56.3547 190.868 57.0065 193.067C57.1538 193.563 57.5249 193.953 58.0422 193.958C58.3773 193.963 58.7751 193.956 59.1787 193.924C59.7853 193.875 60.2736 193.404 60.3292 192.799L60.8592 187.094L56.5264 188.643Z",
    fill: "url(#paint44_linear_1507_9607)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5764 127.996C68.3839 128.932 61.5981 168.516 61.1864 188.999C61.1794 189.343 60.9266 189.63 60.5868 189.678C59.7251 189.799 58.0469 189.953 56.4209 189.651C56.1983 189.61 56.0301 189.426 56.0162 189.2C55.7784 185.383 53.8718 153.11 56.2075 137.918C56.2075 137.918 36.9114 178.529 33.9865 189.728C33.9158 190 33.6653 190.184 33.3834 190.169C32.5565 190.124 30.8389 189.976 29.4739 189.474C28.9845 189.294 28.7061 188.779 28.8302 188.273C30.4643 181.572 41.917 135.4 49.6932 125.227L68.5764 127.996Z",
    fill: "url(#paint45_linear_1507_9607)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2057 138.172C56.1419 138.172 56.0781 138.147 56.0283 138.1C55.9285 138.002 55.9262 137.841 56.0248 137.741L58.6087 135.1C58.7062 135 58.8674 134.998 58.9671 135.096C59.0668 135.194 59.0692 135.355 58.9706 135.454L56.3866 138.096C56.3368 138.146 56.2718 138.172 56.2057 138.172Z",
    fill: "url(#paint46_linear_1507_9607)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6073 78.4363C74.6504 77.1374 65.508 75.1044 58.2294 75.5381C56.5582 75.6378 55.2186 76.96 55.1235 78.6312C54.0241 98.0154 52.5222 115.217 49.6924 125.225C56.0525 127.741 62.357 128.909 68.5768 127.994C73.2367 118.013 77.3109 106.491 80.7914 93.4054C80.7914 93.4054 82.8337 82.9687 80.8505 79.4894C80.5409 78.9478 80.1349 78.5744 79.6073 78.4363Z",
    fill: "url(#paint47_linear_1507_9607)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6844 64.8594C67.6844 64.8594 66.433 72.3259 66.0596 75.7797C65.9993 76.341 66.2927 76.871 66.7949 77.1296C68.1622 77.8336 71.0825 78.9679 74.2649 77.9276C74.7891 77.7559 75.1324 77.2491 75.1208 76.6982L74.9027 66.7301L67.6844 64.8594Z",
    fill: "url(#paint48_linear_1507_9607)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8465 56.584C75.8465 56.584 78.2611 62.1311 78.4235 65.0433C78.5858 67.9554 79.2133 69.8447 75.8465 70.4304C72.4797 71.0172 69.6441 69.339 68.1074 66.4396C68.1074 66.4396 65.6997 61.9711 66.2402 60.1398C66.7806 58.3097 75.8465 56.584 75.8465 56.584Z",
    fill: "url(#paint49_linear_1507_9607)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2582 64.3547H69.6838C69.6838 64.3547 67.9302 60.7583 69.4716 60.1262C71.0129 59.4941 77.1155 58.2497 78.433 56.0844C79.703 53.9969 78.5699 51.2993 76.8766 50.5454C76.7699 50.4979 76.6435 50.5478 76.5878 50.6521L76.4475 50.9177C76.3513 51.0998 76.0834 51.072 76.0254 50.8748C75.9709 50.6869 75.718 50.6463 75.616 50.8122C75.2124 51.4593 74.121 52.5124 71.1938 53.0528C67.0395 53.8194 64.2932 55.5011 64.226 58.3715C64.2213 58.5536 64.0276 58.6533 63.8722 58.5594C63.5661 58.3727 63.0743 58.2845 62.4191 58.8366C61.279 59.7957 61.7452 62.2834 64.2457 64.3303C64.364 64.4278 64.364 64.6133 64.2352 64.6968C63.7818 64.9914 63.1068 65.6942 64.8569 66.6302C66.6475 67.5881 67.7076 67.4837 68.1077 67.3805C68.2155 67.3527 68.2874 67.2553 68.2805 67.1439L68.1228 64.5994C68.1146 64.4684 68.219 64.357 68.3512 64.357H69.2582V64.3547Z",
    fill: "url(#paint50_linear_1507_9607)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3626 64.8879C69.3626 64.8879 68.4418 61.3448 66.8529 62.3376C65.264 63.3315 67.6775 66.3075 68.9544 66.4408L69.3626 64.8879Z",
    fill: "url(#paint51_linear_1507_9607)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8112 122.543L14.55 123.368C8.953 124.783 5.18957 128.988 6.14405 132.762L7.2783 137.248C8.23162 141.021 13.5422 142.934 19.1392 141.519L22.4004 140.694C22.6161 140.64 22.8307 140.581 23.0441 140.517L118.678 111.902L116.208 102.129L18.463 122.395C18.245 122.439 18.0281 122.489 17.8112 122.543ZM19.2157 127.021C23.4291 125.956 27.3584 127.122 27.9905 129.626C28.6237 132.13 25.7208 135.022 21.5074 136.088C17.294 137.153 13.3647 135.987 12.7327 133.483C12.0994 130.979 15.0023 128.086 19.2157 127.021Z",
    fill: "url(#paint52_linear_1507_9607)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M148.005 88.8471L129.081 93.6299C127.734 93.9709 126.621 94.9172 126.068 96.193L123.237 102.731C122.429 104.597 122.978 106.772 124.577 108.031L130.175 112.438C131.267 113.297 132.696 113.601 134.044 113.261L152.968 108.478C155.822 107.757 158.247 110.736 156.899 113.354C153.675 119.617 147.759 124.569 140.23 126.473C126.62 129.913 114.576 121.667 111.267 108.577C107.958 95.4867 114.637 82.5078 128.247 79.068C135.776 77.1648 143.336 78.7119 149.148 82.6899C151.578 84.3518 150.859 88.1257 148.005 88.8471Z",
    fill: "url(#paint53_linear_1507_9607)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M148.456 90.6306L129.532 95.4135C128.185 95.7545 127.071 96.7008 126.519 97.9766L123.688 104.514C122.88 106.38 123.43 108.556 125.028 109.814L130.626 114.221C131.718 115.081 133.147 115.385 134.495 115.045L153.419 110.261C156.273 109.539 158.698 112.519 157.35 115.136C154.126 121.399 148.21 126.351 140.681 128.254C127.071 131.694 115.027 123.45 111.718 110.358C108.41 97.2679 115.09 84.2891 128.698 80.8492C136.228 78.946 143.787 80.4932 149.6 84.4711C152.028 86.1354 151.31 89.9093 148.456 90.6306Z",
    fill: "#455A64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1706 123.965L14.9094 124.789C9.31237 126.204 5.54895 130.41 6.50343 134.184L7.63767 138.669C8.59099 142.443 13.9015 144.356 19.4985 142.941L22.7598 142.116C22.9755 142.062 23.1901 142.003 23.4035 141.939L119.037 113.324L116.567 103.551L18.8224 123.816C18.6044 123.861 18.3875 123.91 18.1706 123.965ZM19.5751 128.443C23.7885 127.378 27.7178 128.544 28.3498 131.048C28.9831 133.551 26.0802 136.444 21.8668 137.51C17.6534 138.574 13.7241 137.409 13.092 134.905C12.4588 132.4 15.3617 129.507 19.5751 128.443Z",
    fill: "url(#paint54_linear_1507_9607)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2957 104.254C39.8452 111.131 41.2253 118.504 41.2253 118.504L37.9942 119.365C37.9942 119.365 33.8202 114.4 34.7747 103.384C37.7576 102.929 40.5515 103.629 42.2957 104.254Z",
    fill: "url(#paint55_linear_1507_9607)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7764 103.384C34.8831 102.146 35.0524 100.834 35.3029 99.4413C37.4856 87.2917 53.0623 77.9451 56.7272 75.8982C57.0681 75.708 57.4822 75.9643 57.4706 76.3551L56.9498 92.8713C48.2748 94.0368 44.1693 99.0006 42.2963 104.254C40.552 103.628 37.7581 102.929 34.7764 103.384Z",
    fill: "url(#paint56_linear_1507_9607)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M100.968 119.609C101.573 119.442 102.065 119.011 102.322 118.438C102.818 117.327 103.376 115.545 102.184 115.004C100.407 114.197 97.1757 117.508 97.1757 117.508L95.5972 120.066L94.1533 120.768C95.4754 121.132 98.0258 120.525 100.968 119.609Z",
    fill: "url(#paint57_linear_1507_9607)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M41.01 116.889H45.0042C45.0042 116.889 41.7638 118.832 41.656 120.876C41.5481 122.919 42.9422 127.154 43.5951 128.305C44.3084 129.566 34.5501 126.429 37.9946 116.889H41.01Z",
    fill: "url(#paint58_linear_1507_9607)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M238.294 312.672V316.096C238.294 316.972 237.844 317.696 237.248 317.775L183.831 322.616C183.434 322.67 183.036 322.661 182.642 322.593C182.539 322.574 182.437 322.552 182.333 322.526L145.114 315.511C144.719 315.409 144.428 314.891 144.428 314.29V310.673L183.918 305.778L189.001 303.373L194.055 304.101L197.04 303.53L203.862 305.515L238.294 312.672Z",
    fill: "url(#paint59_linear_1507_9607)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M238.294 312.672V316.096C238.294 316.973 237.844 317.696 237.248 317.775L183.833 322.616C183.436 322.671 182.942 322.658 182.646 322.592V304.148L189.003 303.371L194.056 304.099L197.04 303.528L203.862 305.513L238.294 312.672Z",
    fill: "url(#paint60_linear_1507_9607)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M197.04 303.529L144.429 310.513L182.377 317.661C182.845 317.78 183.319 317.808 183.789 317.743L238.295 312.674L197.04 303.529Z",
    fill: "url(#paint61_linear_1507_9607)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M216.325 309.838C216.325 312.344 208.44 314.292 197.555 314.797C194.807 314.924 191.87 314.958 188.822 314.889C173.84 314.543 161.803 311.756 161.803 308.671C161.803 308.602 161.811 308.45 161.824 308.45H161.803L161.865 308.301C161.879 308.25 161.899 308.205 161.921 308.158L165.376 299.125L169.549 288.226L175.392 272.951L179.864 261.258L185.427 246.719C186.123 244.898 187.413 243.768 188.807 243.768C188.997 243.768 189.181 243.787 189.364 243.829C190.542 244.085 191.592 245.145 192.195 246.724L197.805 261.365L202.285 273.212L208.197 288.793V288.796L212.441 299.992V299.995L212.509 300.002L216.044 309.1C216.199 309.34 216.325 309.589 216.325 309.838Z",
    fill: "url(#paint62_linear_1507_9607)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M212.512 299.999C209.101 301.139 203.648 301.96 197.121 302.265C194.49 302.389 191.707 302.428 188.807 302.374C178.741 302.182 170.014 300.887 165.369 299.125L169.545 288.225C174.433 289.324 181.244 290.065 188.815 290.179C191.263 290.216 193.649 290.185 195.92 290.093C200.7 289.904 204.915 289.445 208.236 288.793L212.445 299.988V299.992L212.512 299.999Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M202.339 273.209C199.735 273.491 196.873 273.681 193.836 273.768C192.209 273.817 190.533 273.832 188.822 273.816C183.923 273.768 179.339 273.455 175.392 272.951L179.864 261.258C182.662 261.478 185.678 261.605 188.822 261.623C189.933 261.63 191.027 261.623 192.101 261.6C194.073 261.563 195.983 261.484 197.806 261.362L202.339 273.209Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1507_9607",
    x1: 343.643,
    y1: 364.994,
    x2: 106.286,
    y2: 108.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6F8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1507_9607",
    x1: 134.888,
    y1: 255.545,
    x2: 206.03,
    y2: 42.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1507_9607",
    x1: 173.955,
    y1: 149.908,
    x2: 159.196,
    y2: 311.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1507_9607",
    x1: 204.081,
    y1: 97.1402,
    x2: 220.463,
    y2: 97.1402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1507_9607",
    x1: 271.446,
    y1: 9.13657,
    x2: 255.075,
    y2: 44.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1507_9607",
    x1: 261.349,
    y1: 32.9137,
    x2: 230.303,
    y2: 75.5811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676169,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1507_9607",
    x1: 265.026,
    y1: 6.14538,
    x2: 248.655,
    y2: 41.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1507_9607",
    x1: 277.607,
    y1: 12.0085,
    x2: 261.236,
    y2: 47.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1507_9607",
    x1: 261.064,
    y1: 32.7473,
    x2: 234.689,
    y2: 20.2456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1507_9607",
    x1: 286.703,
    y1: 44.9001,
    x2: 260.328,
    y2: 32.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1507_9607",
    x1: 227.479,
    y1: 176.946,
    x2: 260.22,
    y2: 176.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1507_9607",
    x1: 264.35,
    y1: 195.594,
    x2: 278.613,
    y2: 233.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1507_9607",
    x1: 359.454,
    y1: -22.2245,
    x2: 332.122,
    y2: 46.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1507_9607",
    x1: 294.945,
    y1: 290.695,
    x2: 278.153,
    y2: 290.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1507_9607",
    x1: 286.549,
    y1: 256.66,
    x2: 286.549,
    y2: 291.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1507_9607",
    x1: 324.443,
    y1: 290.739,
    x2: 316.58,
    y2: 290.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1507_9607",
    x1: 323.4,
    y1: 264.847,
    x2: 319.865,
    y2: 301.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1507_9607",
    x1: 321.117,
    y1: 285.317,
    x2: 316.016,
    y2: 285.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1507_9607",
    x1: 294.09,
    y1: 284.983,
    x2: 289.838,
    y2: 284.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1507_9607",
    x1: 307.934,
    y1: 233.644,
    x2: 343.353,
    y2: 119.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1507_9607",
    x1: 293.108,
    y1: 232.21,
    x2: 298.769,
    y2: 200.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AE5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1507_9607",
    x1: 264.805,
    y1: 196.638,
    x2: 299.165,
    y2: 198.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1507_9607",
    x1: 281.395,
    y1: 179.248,
    x2: 279.301,
    y2: 166.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1507_9607",
    x1: 272.119,
    y1: 107.854,
    x2: 202.083,
    y2: 169.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1507_9607",
    x1: 267.34,
    y1: 179.44,
    x2: 316.121,
    y2: 112.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1507_9607",
    x1: 264.875,
    y1: 191.416,
    x2: 249.619,
    y2: 232.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1507_9607",
    x1: 301.517,
    y1: 186.267,
    x2: 270.616,
    y2: 220.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1507_9607",
    x1: 265.671,
    y1: 181.41,
    x2: 300.031,
    y2: 183.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1507_9607",
    x1: 303.747,
    y1: 188.272,
    x2: 272.846,
    y2: 222.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1507_9607",
    x1: 272.547,
    y1: 162.351,
    x2: 284.51,
    y2: 155.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1507_9607",
    x1: 290.842,
    y1: 147.363,
    x2: 275.388,
    y2: 159.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1507_9607",
    x1: 275.69,
    y1: 165.072,
    x2: 286.453,
    y2: 158.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1507_9607",
    x1: 259.502,
    y1: 269.123,
    x2: 264.773,
    y2: 230.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1507_9607",
    x1: 265.591,
    y1: 212.04,
    x2: 263.248,
    y2: 227.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1507_9607",
    x1: 259.873,
    y1: 244.947,
    x2: 257.416,
    y2: 256.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1507_9607",
    x1: 68.7478,
    y1: 94.9727,
    x2: 70.9706,
    y2: 94.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1507_9607",
    x1: 68.88,
    y1: 60.9649,
    x2: 144.994,
    y2: 60.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1507_9607",
    x1: 89.6688,
    y1: 105.64,
    x2: 72.437,
    y2: 151.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1507_9607",
    x1: 69.4201,
    y1: 48.6009,
    x2: 75.277,
    y2: 88.4274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186565,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1507_9607",
    x1: 55.6565,
    y1: 196.345,
    x2: 72.7643,
    y2: 196.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1507_9607",
    x1: 64.2105,
    y1: 161.67,
    x2: 64.2105,
    y2: 197.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1507_9607",
    x1: 25.603,
    y1: 196.389,
    x2: 33.6135,
    y2: 196.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1507_9607",
    x1: 26.6659,
    y1: 170.012,
    x2: 30.2671,
    y2: 207.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1507_9607",
    x1: 28.9917,
    y1: 190.866,
    x2: 34.1893,
    y2: 190.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1507_9607",
    x1: 56.5268,
    y1: 190.527,
    x2: 60.8588,
    y2: 190.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1507_9607",
    x1: 76.7067,
    y1: 84.6173,
    x2: 44.1893,
    y2: 189.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1507_9607",
    x1: 67.2985,
    y1: 123.926,
    x2: 49.5682,
    y2: 146.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1507_9607",
    x1: 101.105,
    y1: 76.1671,
    x2: 48.7834,
    y2: 111.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410533,
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1507_9607",
    x1: 62.9767,
    y1: 80.6626,
    x2: 82.109,
    y2: 58.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1507_9607",
    x1: 65.3697,
    y1: 69.8712,
    x2: 51.5645,
    y2: 80.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1507_9607",
    x1: 66.6547,
    y1: 53.1291,
    x2: 79.1555,
    y2: 69.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1507_9607",
    x1: 74.6411,
    y1: 59.2304,
    x2: 60.8359,
    y2: 69.7935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1507_9607",
    x1: 5.99602,
    y1: 122.057,
    x2: 118.678,
    y2: 122.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1507_9607",
    x1: 110.431,
    y1: 102.755,
    x2: 157.282,
    y2: 102.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1507_9607",
    x1: -2337.84,
    y1: 1024.21,
    x2: -2209.29,
    y2: 966.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1507_9607",
    x1: 40.3384,
    y1: 107.567,
    x2: 20.9526,
    y2: 135.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1507_9607",
    x1: 91.446,
    y1: 61.7875,
    x2: 39.1247,
    y2: 96.9287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1507_9607",
    x1: 101.789,
    y1: 110.214,
    x2: 84.5571,
    y2: 155.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1507_9607",
    x1: 47.763,
    y1: 112.637,
    x2: 28.1532,
    y2: 140.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1507_9607",
    x1: 190.743,
    y1: 316.116,
    x2: 207.533,
    y2: 245.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D5F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1507_9607",
    x1: 210.538,
    y1: 309.68,
    x2: 219.909,
    y2: 236.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100C41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1507_9607",
    x1: 199.696,
    y1: 251.459,
    x2: 194.23,
    y2: 290.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DE175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04883B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1507_9607",
    x1: 325.769,
    y1: -35.6214,
    x2: 298.437,
    y2: 33.0987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.fe9f6822f456f7d7f878284571cd32b5.svg";
export { ForwardRef as ReactComponent };